var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TrendView',{ref:"trendview",attrs:{"measurePoints":_vm.measurePoints},on:{"on-close":_vm.closeTrendDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }